import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { classNames } from '../../helpers/classNames';
import { BtnVariant } from '../ButtonVariant';
import styles from './style.module.scss';

interface Props {
    children: React.ReactNode;
    className?: any;
    onMouseDown?: (param: any) => void;
    onClick?: (param: any) => void;
    onDoubleClick?: (param: any) => void;
    variant?: BtnVariant;
    size?: string;
    type?: 'button' | 'submit' | 'reset';
    isDisabled?: boolean;
    icon?: IconProp;
    name?: string;
    value?: string;
    role?: string;
    tabIndex?: number;
}

function Button(props: Props) {
    const {
        className,
        variant = 'primary',
        size,
        type,
        onClick,
        onDoubleClick,
        onMouseDown,
        isDisabled,
        children,
        icon,
        name,
        value,
        role,
        tabIndex,
    } = props;
    return (
        <button
            className={classNames([
                styles.btn,
                className,
                styles[variant],
                size,
                type,
            ])}
            role={role}
            onMouseDown={onMouseDown}
            onClick={onClick}
            disabled={isDisabled}
            name={name}
            onDoubleClick={onDoubleClick}
            value={value}
            tabIndex={tabIndex}
        >
            {icon && (
                <span className={styles.icon}>
                    <FontAwesomeIcon icon={icon} />
                </span>
            )}
            {children}
        </button>
    );
}

export default Button;
